import React, { Children } from "react";
import PropTypes from "prop-types";
import { reduxForm, Field, change } from "redux-form";
import { FormField } from "admin-on-rest";
import { Link } from "react-router-dom";
import RaisedButton from "material-ui/RaisedButton";
import styled from "styled-components";
import { TextField, SelectField } from "redux-form-material-ui";
import { Toolbar } from "admin-on-rest";
import MenuItem from "material-ui/MenuItem";
import { connect } from "react-redux";
import compose from "recompose/compose";
//import { Values } from 'redux-form-website-template';
import { ValuesForm } from "../../components/form/ValuesForm";
import getDefaultValues from "../../components/form/getDefaultValues";
import { renderDateField } from "../../components/form/FieldForm";
import {
  getStatusTransfer,
  dataStatusTransfer,
  datify
} from "../utilsMarketer";

class TransferEditForm extends React.Component {
  handleSubmitWithRedirect = (redirect = this.props.redirect) =>
    this.props.handleSubmit(values => this.props.save(values, redirect));

  constructor(props) {
    super(props);
    this.state = {
      isShow: false
    };
  }
  onOptionChange = (event, value) => {};
  renderItemForm = (children, record, resource, basePath) => {
    let basePath1 = "transfers";
    return Children.map(
      children,
      input =>
        input && (
          <div
            key={input.props.source}
            className={`aor-input-${input.props.source}`}
            style={input.props.style}
          >
            <FormField
              input={input}
              resource={resource}
              record={record}
              basePath={basePath1}
            />
          </div>
        )
    );
  };

  renderIsCompleted(
    children,
    invalid,
    submitOnEnter,
    toolbar,
    resource,
    record,
    basePath,
    translate
  ) {
    return (
      <div>
        <div className="container-form">
          <Container>
            <Box>
              {translate("resources.marketers.transfers.fields.status")}
            </Box>
            <Box>{getStatusTransfer(record.status)}</Box>
          </Container>
          <Container>
            <Box>
              {translate("resources.marketers.transfers.fields.transaction")}
            </Box>
            <Box>{record.transaction_ref}</Box>
          </Container>
          <Container>
            <Box>{translate("resources.marketers.transfers.fields.date")} </Box>
            <Box>{datify(record.created_at)}</Box>
          </Container>
        </div>
        <BoxButton>
          <RaisedButton
            primary
            label="Close"
            containerElement={<Link to={basePath} />}
            style={{ overflow: "inherit" }}
          />
        </BoxButton>
      </div>
    );
  }
  renderIsNotCompleted(
    children,
    invalid,
    submitOnEnter,
    toolbar,
    resource,
    record,
    basePath,
    translate
  ) {
    return (
      <div>
        <div className="container-form">
          <div>
            <Field
              name="transaction_ref"
              component={TextField}
              floatingLabelText={translate(
                "resources.marketers.transfers.fields.transaction"
              )}
            />
          </div>
          <div>
            <Field
              name="status"
              component={SelectField}
              onChange={this.onOptionChange}
              floatingLabelText={translate(
                "resources.marketers.transfers.fields.status"
              )}
            >
              {dataStatusTransfer.map((option, j) => (
                <MenuItem
                  value={option.id}
                  primaryText={`${option.name}`}
                  key={`option-${j}`}
                />
              ))}
            </Field>
          </div>
          <div>
            <Field
              label={translate("resources.marketers.transfers.fields.date")}
              floatingLabelText={translate(
                "resources.marketers.transfers.fields.date"
              )}
              name="created_at"
              component={renderDateField}
            />
          </div>
        </div>

        {toolbar &&
          React.cloneElement(toolbar, {
            handleSubmitWithRedirect: this.handleSubmitWithRedirect,
            invalid,
            submitOnEnter
          })}
      </div>
    );
  }
  render() {
    const {
      children,
      invalid,
      submitOnEnter,
      toolbar,
      resource,
      record,
      basePath,
      translate
    } = this.props;
    return (
      <div>
        <form className="simple-form">
          <div className="container-form">
            <div>
              {this.renderItemForm(children, record, resource, basePath)}
            </div>
          </div>
          {record.status === 8 &&
            this.renderIsCompleted(
              children,
              invalid,
              submitOnEnter,
              toolbar,
              resource,
              record,
              basePath,
              translate
            )}
          {record.status !== 8 &&
            this.renderIsNotCompleted(
              children,
              invalid,
              submitOnEnter,
              toolbar,
              resource,
              record,
              basePath,
              translate
            )}
        </form>
        <ValuesForm isDebug={false} formName={"record-form"} />
      </div>
    );
  }
}

const Box = styled.div`
  font-size: 16px;
`;
const Container = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
  padding-top: 16px;
  color: rgb(120, 129, 149);
  line-height: 24px;
  width: 300px;
  justify-content: space-between;
  font-family: Roboto, sans-serif;
`;

const BoxButton = styled.div`
  background-color: rgb(232, 232, 232);
  height: 56px;
  padding: 0px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

/*
<div style={{width:400}}>
    <Values form="record-form" />
</div>*/
TransferEditForm.propTypes = {
  basePath: PropTypes.string,
  children: PropTypes.node,
  defaultValue: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.string,
    PropTypes.func
  ]),
  handleSubmit: PropTypes.func, // passed by redux-form
  invalid: PropTypes.bool,
  record: PropTypes.object,
  resource: PropTypes.string,
  redirect: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  save: PropTypes.func, // the handler defined in the parent, which triggers the REST submission
  submitOnEnter: PropTypes.bool,
  toolbar: PropTypes.element,
  validate: PropTypes.func,
  translate: PropTypes.func
};

TransferEditForm.defaultProps = {
  submitOnEnter: false,
  toolbar: <Toolbar />
};

const form = "record-form";
const fields = [
  "first_name",
  "last_name",
  "created_at",
  "status",
  "amount",
  "bank",
  "bank_account",
  "transaction"
];
const enhance = compose(
  connect(
    (state, props) => {
      let initialValues = getDefaultValues(state, props);
      return { initialValues };
    },
    dispatch => {
      return {
        // This will be passed as a property to the presentational component
        changeFieldValue: function(field, value) {
          dispatch(change(form, field, value));
        }
      };
    }
  ),
  reduxForm({
    form,
    fields,
    enableReinitialize: true
  })
);

export default enhance(TransferEditForm);



// WEBPACK FOOTER //
// ./src/marketers/transfers/TransferEditForm.js